import { toInteger } from 'lodash';
import type { YesNoOrBothValue } from 'schemas/yes-no-or-both.schema';

/**
 * Converts an array param value (from useQueryParams ArrayParam or DelimitedArrayParam) to an array
 * of strings that does not contain any null values.
 */
export function toArrayOfStrings(values: (string | null)[] | never[]): string[] {
  return values.filter((x) => !!x) as string[];
}

/**
 * Converts an array param value (from useQueryParams DelimitedNumericArrayParam) to an array of
 * numbers that does not contain any null values.
 */
export function toArrayOfNumbers(values: (number | null)[] | never[]): number[] {
  return values.filter((x) => !!x).map((x) => toInteger(x));
}

/**
 * Converts a string to 'Y' (yes), 'N' (no), or '' (both).
 */
export function toYesNoOrBoth(value: string): YesNoOrBothValue {
  if (value === 'Y' || value === 'N') return value;
  return '';
}
